import { NgModule } from '@angular/core';
import { ChatLauncherComponent } from './components/chat-launcher/chat-launcher.component';
import { ChatTriggerComponent } from './components/chat-trigger/chat-trigger.component';

/**
 * Remmi internal chat.
 *
 * Everything in the module is standalone; this NgModule exists only so the app shell can import
 * one thing and mount `<app-chat-launcher>` in `full.component.html` — the same pattern
 * {@link AiAssistantModule} uses for its floating panel.
 *
 * `<app-chat-trigger>` is the button for it, mounted separately in the top bar. It is a second
 * export rather than something the launcher renders because the two cannot share a DOM position:
 * the header is a stacking context and the panel has to escape it.
 *
 * The full-page screen at `/chat` is lazy-loaded straight from `app-routing.module.ts` via
 * `loadComponent`, so it never rides along with the app bundle.
 *
 * Backend contract: `docs/backend/chat/internal-chat.md`.
 */
@NgModule({
  imports: [ChatLauncherComponent, ChatTriggerComponent],
  exports: [ChatLauncherComponent, ChatTriggerComponent],
})
export class ChatModule {}
